import React, { Component } from 'react';
import * as pt from 'prop-types';
import ReactSelect from 'react-select';
import _ from 'underscore';
import { Link } from 'react-router-dom'

class EncoderSelect extends Component {
    constructor (props) {
        super(props);

        const event = this.props.event.toJS();
        this.state = {
            selected: event.assignedEncoder ?
                event.assignedEncoder.encoderID :
                null
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (ev) {
        const value = ev.value;
        this.setState({
            selected: value
        });
        this.props.handleChange('assignedEncoder', {
            simpleName: _.findWhere(
                this.props.encoders.data,
                {'encoderID': value}
            ).simpleName,
            encoderID: value
        });
    }

    render () {
        let { encoders } = this.props;
        let { selected } = this.state;
        
        if (this.props.edits.hasOwnProperty('assignedEncoder')) {
            selected = this.props.edits.assignedEncoder.encoderID || null
        }
        

        if (!encoders.data.length) {
            return (<div className="alert alert-warning">
                <h4>You Need to Setup an Encoder!</h4>
                <p>You can Create and Edit your Encoder connections <Link to="/manage/encoders">here &hellip;</Link></p>
            </div>);
        }

        const encoderOptions = [];
        encoders.data.map(function (enc, k) {
            encoderOptions.push({
                label: <span>{enc.simpleName} {
                    (enc.online ?
                        <em className="online">&mdash;&nbsp;<strong>Online</strong></em> :
                        <em className="offline">&mdash;&nbsp;Offline</em>)
                }</span>,
                value: enc.encoderID
            })
        });

        return (<div id="encoder-select">
            <label htmlFor="select-encoder">
                Select an Encoder &hellip;
            </label>

            <ReactSelect
              name="select-encoder"
              value={selected}
              onChange={this.handleChange}
              options={encoderOptions}
            />
        </div>);
    }
}

EncoderSelect.propTypes = {};

export default EncoderSelect;
